import eggsIMG from "./images/Group 105551920.png";
import milkIMG from "./images/Group 105821920.png";
import paperCupIMG from "./images/Group 105851920.png";
import spoonIMG from "./images/Group 105731920.png";
import eggSVG from "./images/baker.svg";
import milkSVG from "./images/Phaitong Station - F&B Supplier 1.svg";
import paperSVG from "./images/Group 10517.svg";
import spoonSVG from "./images/Group 10553.svg";
import eggs768IMG from "./images/Group 10555.png";
import cup768IMG from "./images/Group 10585cup768.png";
import milk768IMG from "./images/Group 10582milk768.png";
import spoon678IMG from "./images/Group 10591spoon768.png";

const info = [
  {
    id: 1,
    img: eggsIMG,
    img768: eggs768IMG,
    logo: eggSVG,
    name: "Fathira Dida",
    position: "OWNER (BAKER OLD)",
    text: "Tinvio definitely helps to reduce the time and errors in order management between customers and suppliers. It’s super easy to use and available on mobile and web, and the team are friendly and always helpful.",
    aka: "eggs",
  },
  {
    id: 2,
    img: milkIMG,
    img768: milk768IMG,
    logo: milkSVG,
    name: "Punnasiri Chaipatikul",
    position: "BUSINESS DEVELOPMENT MANAGER (PHAITONG STATION)",
    text: "Tinvio helps our business run smoother. We can manage our customer's orders, receivables, and most importantly, trace and reconcile their payments without checking banking apps or statements.",
    aka: "milk",
  },
  {
    id: 3,
    img: paperCupIMG,
    img768: cup768IMG,
    logo: paperSVG,
    name: "Pauline Limgenco",
    position: "DIRECTOR (MOONLEAF)",
    text: "With Tinvio, it's easier for my customers to make payments across various methods. Every payment is also collected in one business account where funds can be withdrawn instantly at any time.",
    aka: "cup",
  },
  {
    id: 4,
    img: spoonIMG,
    img768: spoon678IMG,
    logo: spoonSVG,
    name: "Hafidz & Indah",
    position: "OWNERS (SEJADAH GROCERY)",
    text: "Tinvio has been a foundational partner and solution. We now have faster and more efficient communication with our clients, which makes order processing and deliveries smoother than ever before.",
    aka: "spoon",
  },
];

export default info;
